import React from "react";
import MonogramTile from "./MonogramTile";

export default function ProductGallery({ product }) {
  return (
    <MonogramTile name={product.game_name || product.name} label={product.category_slug}
      className="border border-[#35353B] rounded-lg w-full h-56 sm:h-72 lg:h-full lg:min-h-[420px]"
      textSize="text-7xl lg:text-8xl" testId="product-detail-img" />
  );
}
